import cn from 'classnames'
import type { ReactNode } from 'react'

import { ChevronIcon } from '../../lib/icons'

import styles from './HelpPanelRow.module.scss'

interface IHelpPanelRowProps {
  icon: ReactNode
  title: ReactNode
  subtitle?: ReactNode
  /** Without one, the row is a link onward and ends in a chevron. */
  end?: ReactNode
  disabled?: boolean
  onClick?: () => void
}

/** One line of the panel: an icon, a title with an optional line under it, and what closes the
 *  row — a chevron on a row that leads somewhere, or a control of its own. */
export const HelpPanelRow = ({
  icon,
  title,
  subtitle,
  end,
  disabled = false,
  onClick,
}: IHelpPanelRowProps) => {
  const content = (
    <>
      <span className={styles.icon}>{icon}</span>
      <span className={styles.text}>
        <span className={styles.title}>{title}</span>
        {subtitle && <small className={styles.subtitle}>{subtitle}</small>}
      </span>
      {end ?? <ChevronIcon className={styles.chevron} />}
    </>
  )

  if (end) {
    return <div className={cn(styles.root, { [styles.disabled]: disabled })}>{content}</div>
  }

  return (
    <button
      type="button"
      className={cn(styles.root, styles.link, { [styles.disabled]: disabled })}
      disabled={disabled}
      onClick={onClick}
    >
      {content}
    </button>
  )
}

HelpPanelRow.displayName = 'HelpPanelRow'
